import React, { useState } from 'react';
import ReactModal from 'react-modal';
import notifications from '../../notifications';
import { updateKid } from '../../api/admin';
import './EditKidModal.css';

const EditKidModal = ({ kid, onSuccess, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: kid.firstName || '',
    lastName: kid.lastName || '',
    dob: kid.dob || '',
    gender: kid.gender || '',
    contactFirstName: kid.contactFirstName || '',
    contactLastName: kid.contactLastName || '',
    contactPhone: kid.contactPhone || '',
    contactEmail: kid.contactEmail || ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await updateKid(kid.kidId, formData);
      if (!response.error) {
        notifications.notifySuccess('Kid info updated');
        onSuccess();
      } else {
        notifications.notifyError(response.error?.error || 'Failed to update kid');
      }
    } catch (error) {
      notifications.notifyError('An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      contentLabel="Edit Kid"
      ariaHideApp={false}
      className="edit-kid-modal-content"
      overlayClassName="modal-overlay"
    >
      <div className="edit-kid-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Edit Kid Info</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select...</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Contact First Name</label>
              <input
                type="text"
                name="contactFirstName"
                value={formData.contactFirstName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Contact Last Name</label>
              <input
                type="text"
                name="contactLastName"
                value={formData.contactLastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Contact Phone</label>
              <input
                type="tel"
                name="contactPhone"
                value={formData.contactPhone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Contact Email</label>
              <input
                type="email"
                name="contactEmail"
                value={formData.contactEmail}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={onClose} disabled={isLoading}>
              Cancel
            </button>
            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </ReactModal>
  );
};

export default EditKidModal;
